/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetSampleRequestQueryResponse,
  GetSampleRequestPathParams,
  GetSampleRequest404,
} from '../../types/GetSampleRequest'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getSampleRequest } from '../../clients/getSampleRequest'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getSampleRequestQueryKey = ({
  id,
}: {
  id: GetSampleRequestPathParams['id']
}) =>
  [{ url: '/api/v1/samples/sample-requests/:id/', params: { id: id } }] as const

export type GetSampleRequestQueryKey = ReturnType<
  typeof getSampleRequestQueryKey
>

export function getSampleRequestQueryOptions(
  { id }: { id: GetSampleRequestPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getSampleRequestQueryKey({ id })
  return queryOptions<
    GetSampleRequestQueryResponse,
    ResponseErrorConfig<GetSampleRequest404>,
    GetSampleRequestQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getSampleRequest(
        { id: id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Retrieve a single sample request with detailed serialization.
 * @summary Get sample request detail
 * {@link /api/v1/samples/sample-requests/:id/}
 */
export function useGetSampleRequest<
  TData = GetSampleRequestQueryResponse,
  TQueryData = GetSampleRequestQueryResponse,
  TQueryKey extends QueryKey = GetSampleRequestQueryKey,
>(
  { id }: { id: GetSampleRequestPathParams['id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetSampleRequestQueryResponse,
        ResponseErrorConfig<GetSampleRequest404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getSampleRequestQueryKey({ id })

  const query = useQuery(
    {
      ...getSampleRequestQueryOptions({ id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetSampleRequest404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
